<template>
    <div class="main-container">
      <MainHeroSlider/>
      <SectionHeading text-key="homeNew.backedByScience" />
      <MainHealthClubSlider />
      <SectionHeading text-key="homeNew.connectedToResults" />
      <MainWorkSlider />
      <MainBasicTrainingZone />
      <MainStartOffers />
      <MainContacts/>
      <MainForm/>
    </div>
</template>

<script>

import { useMeta } from 'vue-meta'
// import SiteHeader from "@/components/common/SiteHeader";
import MainHeroSlider from "@/components/main/MainHeroSlider";
import SectionHeading from "@/components/common/SectionHeading";
import MainHealthClubSlider from "@/components/main/MainHealthClubSlider";
import MainWorkSlider from "@/components/main/MainWorkSlider";
import MainBasicTrainingZone from "@/components/main/MainBasicTrainingZone";
import MainStartOffers from "@/components/main/MainStartOffers";
import MainContacts from "@/components/common/MainContacts";
import MainForm from "@/components/common/MainForm";
// import MainFooter from "@/components/common/MainFooter";

export default {
  name: 'HomeView',
  components: {
    // MainFooter,
    MainForm,
    MainContacts,
    MainStartOffers,
    MainBasicTrainingZone,
    MainHealthClubSlider,
    MainWorkSlider,
    SectionHeading,
    MainHeroSlider,
    // SiteHeader,

  },
  beforeMount() {
    useMeta({
      title: this.$t('pagenames.home') + " | AI gym",
      link: [
        { rel: 'canonical', href: 'https://35fit.com/' },
      ],
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      meta: [
        { property: "og:title", content: "35FIT | " + this.$t('pagenames.home') + " | AI gym" },
        { property: "og:description", content: this.$t('meta.home') },
        { property: "og:url", content: "https://35fit.com" },
      ],
      description: this.$t('meta.home'),
    })
  },
  data() {
    return {
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.loggedOut = false;
    } else {
      this.loggedOut = true;
    }
  },

  methods: {
  },


}
</script>

<style>

.wrapper {
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  //position: relative;
  padding: 60px 0 0 0;
  //margin: 0;
  //min-height: 100vh;
}

@media screen and (min-width: 1024px) {
  .wrapper {
    padding: 96px 0 0 0;
  }
}

.main-container {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
</style>
